<div class="contents" [class.booking-styling]="onBookings" [class.auth-bar]="(isAuthed$ | async) === true">
  <as-split
    class="as-split-container"
    unit="percent"
    [direction]="(isMobile$ | async) ? 'vertical' : 'horizontal'"
    useTransition="true"
    #split="asSplit"
    [gutterSize]="(isMobile$ | async) ? 30 : 15"
  >
    <as-split-area
      [visible]="showMap"
      size="50"
      #area1="asSplitArea"
      order="1"
      minSize="30"
      [class.side-bar-padding]="(isAuthed$ | async) === false"
    >
      <google-map #map id="map" [options]="mapOptions" height="100%" width="100%" [center]="center" [zoom]="12">
        <map-info-window>
          <div *ngIf="infoWindowDoctors; else yourLocation">
            <div class="doctor-card" *ngFor="let doctor of infoWindowDoctors">
              <gc-doctor-card [doctor]="doctor" [minimal]="true"></gc-doctor-card>
            </div>
          </div>
          <ng-template #yourLocation>
            <h1>{{ 'you_are_here' | translate }}</h1>
          </ng-template>
        </map-info-window>
      </google-map>
    </as-split-area>
    <as-split-area size="50" #area2="asSplitArea" minSize="30" order="2">
      <div
        class="search-contents"
        [class.extra-top-padding]="(isMobile$ | async) && !showMap"
        [class.auth-bar]="(isAuthed$ | async) === false"
      >
        <div
          class="search-bar"
          [class.expanded]="searchExpand"
          [class.margin-top]="(isAuthed$ | async) === true && (isMobile$ | async) === true"
        >
          <form class="search" [formGroup]="searchForm" (submit)="clickSearch()">
            <div *ngIf="practice && (isMobile$ | async) === false" class="practice">
              <span class="practice-info">
                <span class="title">
                  <img *ngIf="practice.logo" [src]="practice.logo | safe" alt="{{ 'mygc_logo' | translate }}" class="practice-logo" />
                  <h1>{{ practice?.name }}</h1>
                </span>
                <gc-communication-actions
                  [landlines]="practice.contactNumbers"
                  [emailAddress]="practice.emailAddresses?.[0]"
                ></gc-communication-actions>
              </span>
              {{ 'results_found_count' | translate: { doctorsLength: doctorsLength } }}
            </div>
            <!-- This is shown when the search is expanded: -->
            <div class="search-expanded" *ngIf="searchExpand" [@inOutAnimation]>
              <div *ngIf="!onBookings && (isMobile$ | async)" class="mobile-search-header">
                <button mat-icon-button type="button" (click)="hamburgerClick.emit($event)">
                  <mat-icon svgIcon="menu"></mat-icon>
                </button>
                <img src="assets/images/myGCLogo_menu-dark.svg" alt="{{ 'mygc_logo' | translate }}" />
              </div>
              <div class="heading-row">
                <mat-icon svgIcon="magnify"></mat-icon>
                <span class="heading">{{ 'search' | translate }}</span>
                <mat-icon svgIcon="close" (click)="searchExpand = false"></mat-icon>
              </div>
              <div class="search-form">
                <div class="location">
                  <mat-form-field>
                    <mat-label>{{ 'location' | translate }}</mat-label>
                    <mat-icon svgIcon="map-marker" matPrefix></mat-icon>
                    <button
                      type="button"
                      mat-icon-button
                      *ngIf="searchForm.controls.location.value"
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="clearLocation()"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                    <input
                      matInput
                      type="text"
                      type="text"
                      formControlName="location"
                      #locationInput
                      (focus)="locationFocused = true"
                      [matAutocomplete]="autoLocation"
                      (keyup)="populateAddressFields($event)"
                    />
                    <mat-autocomplete #autoLocation="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)">
                      @for (option of addressSuggestions; track option) {
                        <mat-option [value]="option">
                          {{ option.placePrediction?.text?.text }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div class="doctor-search">
                  <mat-form-field class="doctor-search-input">
                    <mat-label>{{ 'speciality' | translate }}</mat-label>
                    <input
                      matInput
                      [formControl]="specialityAutoCompleteControl"
                      type="text"
                      [matAutocomplete]="specialityAutocomplete"
                      placeholder="{{ 'any_speciality' | translate }}"
                    />
                    <mat-icon svgIcon="medical-bag" matPrefix></mat-icon>
                    <mat-autocomplete
                      (optionSelected)="searchForm.controls.speciality.setValue($event.option.value)"
                      #specialityAutocomplete="matAutocomplete"
                    >
                      <mat-option *ngFor="let speciality of filteredSpecialities$ | async" [value]="speciality">
                        {{ speciality }}
                      </mat-option>
                    </mat-autocomplete>
                    <button
                      type="button"
                      mat-icon-button
                      *ngIf="searchForm.controls['speciality'].value"
                      matSuffix
                      aria-label="Clear"
                      (click)="clearSpeciality()"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                    <mat-icon matSuffix *ngIf="searchForm.controls['speciality'].value === ''">arrow_drop_down</mat-icon>
                    <mat-hint *ngIf="!(filteredSpecialities$ | async)?.includes(searchForm.controls['speciality'].value)">
                      {{ 'please_select_speciality_from_list' | translate }}
                    </mat-hint>
                  </mat-form-field>
                  <mat-form-field class="doctor-search-input">
                    <mat-label>{{ 'search_a_name' | translate }}</mat-label>
                    <mat-icon svgIcon="doctor" matPrefix></mat-icon>
                    <input matInput type="text" formControlName="searchTerm" gcFormField gcFormFieldNoError />
                    <button
                      type="button"
                      mat-icon-button
                      *ngIf="searchForm.controls['searchTerm'].value"
                      matSuffix
                      aria-label="Clear"
                      (click)="clearSearchTerm()"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
              </div>
              <div class="heading-row">
                <mat-icon svgIcon="tune"></mat-icon>
                <span class="heading">{{ 'filters' | translate }}</span>
              </div>
              <form [formGroup]="filterForm">
                <mat-button-toggle-group formControlName="orderControl" class="gc-button-toggle primary">
                  <mat-button-toggle class="gc-button-toggle" value="distance">{{ 'order_by_distance' | translate }}</mat-button-toggle>
                  <mat-button-toggle class="gc-button-toggle" value="time">{{ 'order_by_time' | translate }}</mat-button-toggle>
                </mat-button-toggle-group>
                <div class="toggle-list">
                  <div class="row-space-between">
                    <mat-icon class="toggle-icon" svgIcon="account-multiple"></mat-icon>
                    <div class="toggle-item">
                      <span>{{ 'in_person_consult' | translate }}</span>
                      <button type="button" mat-icon-button class="info-icon" (click)="showBookingInfoDialog()">
                        <mat-icon svgIcon="information-outline"></mat-icon>
                      </button>
                    </div>
                    <mat-slide-toggle formControlName="inPersonControl" color="primary"></mat-slide-toggle>
                  </div>
                  <div class="row-space-between">
                    <mat-icon class="toggle-icon" svgIcon="video"></mat-icon>
                    <div class="toggle-item">
                      <span>{{ 'telemed_consult' | translate }}</span>
                      <button type="button" mat-icon-button class="info-icon" (click)="showBookingInfoDialog()">
                        <mat-icon svgIcon="information-outline"></mat-icon>
                      </button>
                    </div>
                    <mat-slide-toggle formControlName="telemedControl" color="primary"></mat-slide-toggle>
                  </div>
                </div>
              </form>
              <div class="buttons row-space-between">
                <button mat-raised-button class="clear" type="button" (click)="clearFilters()">{{ 'clear' | translate }}</button>
                <button mat-raised-button color="accent" type="submit" [disabled]="!searchForm.valid">{{ 'search' | translate }}</button>
              </div>
            </div>
            <!-- This is shown when the search is collapsed: -->
            <div class="search-collapsed row-space-between" *ngIf="!searchExpand">
              <div *ngIf="!onBookings && (isMobile$ | async)" class="row-space-between">
                <button mat-icon-button type="button" (click)="hamburgerClick.emit($event)" id="sidebar-menu">
                  <mat-icon svgIcon="menu"></mat-icon>
                </button>
                <div class="small-logo">
                  <span class="practice-info">
                    <img *ngIf="practice?.logo" [src]="practice.logo | safe" alt="{{ 'mygc_logo' | translate }}" class="practice-logo" />
                    {{ practice?.name }}
                  </span>
                  <img *ngIf="!practice?.logo" src="assets/images/myGCLogo_menu-dark.svg" alt="myGC Logo" />
                </div>
                <mat-icon class="magnify" svgIcon="magnify" (click)="searchExpand = true"></mat-icon>
              </div>
              <div
                [class.underline]="onBookings"
                class="results"
                (click)="searchExpand = true"
                *ngIf="!practice && (onBookings || (isMobile$ | async) === false)"
              >
                <span [class.on-bookings]="onBookings">
                  <b class="primary-color">#{{ doctorsLength }}</b>
                  <ng-container *ngIf="(isMobile$ | async) === false">
                    <span
                      [class.on-bookings]="onBookings"
                      *ngIf="searchForm.controls.searchTerm.value || searchForm.controls.speciality.value"
                    >
                      {{ 'results_found_for' | translate: { searchResultText: searchResultText } }}
                    </span>
                    <span [class.on-bookings]="onBookings" *ngIf="this.address">
                      {{ 'results_found_near' | translate: { address: address } }}
                    </span>
                  </ng-container>
                </span>
                <mat-icon class="magnify" svgIcon="magnify"></mat-icon>
              </div>
              <mat-icon
                *ngIf="isMobile$ | async"
                class="map"
                [class.active]="showMap"
                svgIcon="map"
                (click)="showMap = !showMap"
              ></mat-icon>
            </div>
          </form>
        </div>
        <ng-container *ngIf="filteredDoctors$ | async as doctors; else loading">
          <div (click)="searchExpand = false" class="doctor-cards" [class.blur]="searchExpand && (isMobile$ | async) === false">
            <div *ngIf="doctors.length; else empty" class="doctor-list">
              <div class="doctor-card-container" *ngFor="let doctor of doctors">
                <gc-doctor-booking-card [loadingTimeslots]="isLoadingTimeslots(doctor)" [doctor]="doctor"></gc-doctor-booking-card>
              </div>
            </div>
            <ng-template #empty>
              <div *ngIf="finishedLoading; else loading" class="loading">
                <h3>{{ 'no_doctors_found' | translate }}</h3>
              </div>
            </ng-template>
          </div>
        </ng-container>
        <ng-template #loading>
          <div class="fetching-doctor-text">
            <h3 class="heading-1">{{ 'fetching_doctors' | translate }}</h3>
            <mat-spinner></mat-spinner>
          </div>
        </ng-template>
      </div>
    </as-split-area>
  </as-split>
</div>
